"use client";

import React from "react";
import { CircleCheck, Target, Lightbulb, Users } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutHero() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const values = [{
    icon: <Lightbulb className="size-5 text-primary" />,
    title: "Eccellenza",
    description: "Standard qualitativi superiori per ogni pratica di mobilità internazionale."
  }, {
    icon: <Target className="size-5 text-primary" />,
    title: "Precisione",
    description: "Gestione meticolosa di visti e documentazione per risultati garantiti."
  }, {
    icon: <Users className="size-5 text-primary" />,
    title: "Globalità",
    description: "Una rete internazionale al servizio di aziende, studenti e istituti."
  }];
  return <section data-section-id="248581" id="global-talent-mobility" className="dark bg-[#091221] text-foreground relative overflow-hidden py-16 md:py-24 lg:py-32">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none">
        <div className="absolute -top-[20%] -right-[10%] w-[50%] h-[50%] rounded-lg bg-primary/10 blur-[120px]" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-lg bg-secondary/10 blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div ref={textRef} className={`flex flex-col space-y-8 transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-4">
              <div className="inline-flex items-center border border-primary/30 bg-primary/5 px-3 py-1 text-sm font-mono font-medium text-primary tracking-widest uppercase">
                <span className="flex size-2 rounded-lg bg-primary mr-2 animate-pulse"></span>
                La Nostra Visione
              </div>
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-default text-accent tracking-tighter">
                Mobilità globale di lavoratori qualificati
              </h1>
              <p className="text-lg md:text-xl text-muted-foreground font-default font-light leading-relaxed max-w-2xl">
                World Immigration di Delgado ridefinisce i confini della mobilità internazionale. Offriamo soluzioni premium per l'immigrazione e visti, garantendo affidabilità e prestigio globale.
              </p>
            </div>

            <div className="grid gap-6 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-1">
              {values.map((value, i) => <div key={i} data-index={i} className="flex gap-4 items-start">
                  <div className="flex-shrink-0 mt-1 bg-primary/10 p-2 border border-primary/20">
                    {value.icon}
                  </div>
                  <div>
                    <h3 className={`font-bold font-default text-lg tracking-tight ${value.title === "Eccellenza" || value.title === "Precisione" || value.title === "Globalità" ? "text-accent" : "text-foreground"}`}>
                      {value.title}
                    </h3>
                    <p className="text-muted-foreground font-default font-light mt-1">{value.description}</p>
                  </div>
                </div>)}
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="relative overflow-hidden shadow-4xl border border-primary/20 aspect-[4/5] md:aspect-square lg:aspect-[4/5]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/corporate_mobility_nexus.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/corporate_mobility_nexus.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/corporate_mobility_nexus.png-wvc-sizes" alt="World Immigration Corporate Excellence" className="object-cover w-full h-full grayscale-[20%] hover:grayscale-0 transition-all duration-700" loading="lazy" />
              
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent pointer-events-none" />
              
              {}
              <div className="absolute bottom-6 left-6 right-6 bg-background/90 backdrop-blur-md p-4 shadow-2xl border border-primary/30 flex items-center gap-4">
                <div className="bg-primary/20 p-3 text-primary">
                  <CircleCheck className="size-6" />
                </div>
                <div>
                  <p className="font-bold text-foreground font-default tracking-tight">Status Internazionale</p>
                  <p className="text-sm text-muted-foreground font-default font-light">Eccellenza nei servizi extragiudiziali</p>
                </div>
              </div>
            </div>
            
            {}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-[radial-gradient(circle,var(--color-primary)_2px,transparent_2px)] bg-[size:12px_12px] opacity-30 -z-10" />
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-[radial-gradient(circle,var(--color-secondary)_2px,transparent_2px)] bg-[size:12px_12px] opacity-30 -z-10" />
          </div>

        </div>
      </div>
    </section>;
}